import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimeline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m3 14 .5.07 4.57-4.57c-.18-.65-.01-1.39.52-1.91.78-.79 2.04-.79 2.82 0 .53.52.7 1.26.52 1.91l2.57 2.57.5-.07c.18 0 .35 0 .5.07l3.57-3.57c-.07-.15-.07-.32-.07-.5a2 2 0 0 1 2-2 2 2 0 0 1 2 2 2 2 0 0 1 -2 2c-.18 0-.35 0-.5-.07l-3.57 3.57c.07.15.07.32.07.5a2 2 0 0 1 -2 2 2 2 0 0 1 -2-2l.07-.5-2.57-2.57c-.32.07-.68.07-1 0l-4.57 4.57.07.5a2 2 0 0 1 -2 2 2 2 0 0 1 -2-2 2 2 0 0 1 2-2z"
	})
});
export default SvgTimeline;
